<div
	*ngIf="show"
	class="flex flex-1 fixed top-0 left-0 w-full h-full items-center justify-center bg-black bg-opacity-{{
		opacity
	}} text-white"
	[testHook]="testHooks.LoadingDiv"
>
	{{ text }}
</div>
